import { isOnScreen } from '../utils/_is-on-screen'

export default function ScrollAnimations () {
  const ELEMENTS = document.querySelectorAll('[data-animation-name]')

  if (ELEMENTS.length > 0) {
    for (let i = 0; i < ELEMENTS.length; i++) {
      const SCROLL_ANIMATION = new ScrollAnimation(ELEMENTS[i])
    }
  }
}

class ScrollAnimation {
  constructor (EL) {
    this.EL = EL
    this.DATA_NAMES = {
      name: 'data-animation-name',
      status: 'data-animation-done',
      delay: 'data-animation-delay'
    }
    this.ANIMATION = this.EL.getAttribute(this.DATA_NAMES.name)
    this.STATUS = this.EL.getAttribute(this.DATA_NAMES.status) === 'true'
    this.DELAY = this.EL.getAttribute(this.DATA_NAMES.delay)

    window.addEventListener('scroll', () => this.scrollEvent())
    this.scrollEvent()
  }

  scrollEvent () {
    if (!isOnScreen(this.EL) || this.STATUS) return
    setTimeout(() => this.updateStatus(), this.DELAY)
  }

  updateStatus (val = true) {
    this.STATUS = val
    this.EL.setAttribute(this.DATA_NAMES.status, val)
  }
}
